import { colors } from '../../Colors/colors'

export const selfServeCommon = {
   light: {
      createPipelineModel: {
         iconAndColorTitleColor: 'text-gray-900',
         iconAndColorDescriptionColor: 'text-gray-600',
         backBtnIconColor: colors['gray-600']
      },
      fieldsOverview: {
         defaultDescriptionColor: 'text-gray-600',
         noDataViewHeaderTextColor: 'text-gray-700',
         plusIconColor: colors['gray-500']
      }
   },
   dark: {}
}
